export const NOTIFICATION_TYPE = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
};

export const LOCALE = {
  JAPANESE: "jp",
  ENGLISH: "en",
};

export const LOCAL_STORAGE_KEY = {
  USER_INFO: "user_info",
  USER_ID: "user_id",
  USER_TOKEN: "user_token",
  REFRESH_TOKEN: "refresh_token",
  LANGUAGE: "language",
  USER_GROUP: "user_group",
  SEARCH_CONDITIONS: "search_conditions",
  EXPIRE_TIME: "expire_time",
  LAST_EXPIRE_TIME: "last_expire_time",
  OWNER_ID: "owner_id",
  ORGANIZATION: "organization",
  REDIRECT: "redirect",
  DENSHI: "denshi",
  TOKUBAI: "tokubai",
  BIDASHBOARD: "bidashboard",
  FORECAST: "forecast",
  INTRANET: "intranet",
  ECM: "ecm",
  NEBIKI: "nebiki",
  BAKERY: "bakery",
  NOTIFICATION_PERMISIION: "notification_permission",
  LIST_USER: "list_user",
  USER_ROLE_KOJI: "user_role_koji",
  APPROVER_TASK: "approver_task",
  ID_TOKEN: "idToken",
  LOGIN_DEVICE: "loginDevice",
  REFRESH_ISSUED_AT: "refreshIssuedAt",
  REFRESH_EXPIRES_AT: "refreshExpiresAt",
};

export const ROLE_OPTIONS = [
  { value: "root", label: "ルート" },
  { value: "manager", label: "管理者" },
  { value: "normal", label: "一般" },
];

export const APPROVE_TAB = {
  ALL: "all",
  CREATE: "0",
  APPROVED: "1",
  REJECT: "2",
  WAITING_DELETE: "3",
  FORM_SHARED: "4",
};

export const SYSTEM_CONSTANT = {
  SYSTEM_HOURS_MINUTES_FORMAT: "HH:mm",
  SYSTEM_LOCAL_DATE_FORMAT: "yyyy-MM-DD",
  SYSTEM_LOCAL_DATE_FORMAT_YYYY_MM_DD: "yyyy/MM/DD",
  SYSTEM_LOCAL_DATE_TIME_FORMAT: "yyyy-MM-DD HH:mm",
  SYSTEM_LOCAL_DATE_TIME_FORMAT_YYYY_MM_DD: "yyyy/MM/DD HH:mm:ss",
  SYSTEM_LOCAL_DATE_TIME_FORMAT_YYYY_MM_DD_1: "yyyy-MM-DD HH:mm:ss",
  SYSTEM_LOCAL_DATE_FORMAT_YYYY_MM_DD_HH_MM: "yyyy/MM/DD HH:mm",
  SYSTEM_LOCAL_DATE_TIME_STRING: "YYYYMMDDHHmmss",
  SYSTEM_LOCAL_DATE_FORMAT_WITH_TEXT_YYYY_MM_DD: 'YYYY年MM月DD日',
  SYSTEM_LOCAL_DATE_TIME_FORMAT_YYYY_MM_DD_2: "YYYY-MM-DD HH:mm:ss",
  SYSTEM_LOCAL_DATE_TIME_FORMAT_YYYY_MM_DD_3: "YYYY/MM/DD HH:mm",
};

export const REGEX_PHONE_NUMBER = /^0\d{9,10}$/;

export const REGEX_USERNAME = /^[a-zA-Z0-9._]*$/;
export const REGEX_VERIFICATION = /^[0-9]*$/;
export const REGEX_KATAKANA = /^([ｧ-ﾝﾞﾟァ-ン]|ー)*$/;
export const REGEX_PASSWORD =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.\\[\]{}\\(\\)?\-“!@#%&/,><\\’:;|_~`])\S{8,99}$/;

export const SIGNIN_ERROR_TYPE = {
  USER_NOT_CONFIRMED: "User is not confirmed.",
  INCORRECT_USERNAME_OR_PASSWORD: "Incorrect username or password.",
  USER_NOT_EXIST: "User does not exist.",
  NEED_CONFIRM_FROM_ADMIN:
    "PreAuthentication failed with error Error: Needs confirmation from admin.",
  EMAIL_VERIFIED:
    "PreAuthentication failed with error Error: 'email_verified'.",
  EMAIL_NOT_VERIFIED:
    "PreAuthentication failed with error Error: Email not verified.",
};

export const SIGNUP_ERROR_TYPE = {
  USERNAME_EXISTS: "UsernameExistsException",
  EMAIL_EXISTS:
    "PreSignUp failed with error Error: User with this email already exists..",
};

export const CONFIRM_SIGNUP_ERROR_TYPE = {
  CODE_EXPIRED: "ExpiredCodeException",
  CODE_MISMATCH: "CodeMismatchException",
  CODE_INVALID: "InvalidParameterException",
};

export const FORGOT_PASSWORD_ERROR_TYPE = {
  CODE_INCORRECT: "CodeMismatchException",
  INVALID_EXCEPTION: "InvalidParameterException",
};

export const CHANGE_PASSWORD_ERROR_TYPE = {
  INCORRECT_PASSWORD: "Incorrect username or password.",
};

export const TOTAL_COUNT_INIT = 0;

export const PAGE_DEFAULT = 1;

export const PAGE_SIZE_DEFAULT = 20;

export const FORM_STATUS = {
  APPROVE: 1,
  REJECT: 2,
  CREATE: 0,
  WAITING_DELETE: 3,
};

export const USER_STATUS = {
  ACTIVE: "1",
  INACTIVE: "0",
};

export const USER_GROUP = {
  PLATFORM_ADMIN: "platform_admin",
  ADMIN: "admin",
  APPROVER: "approver",
  CREATOR: "creator",
};

export const USER_ROLE = {
  ROOT: "root",
  MANAGER: "manager",
  NORMAL: "normal",
};

export const FORM_TYPE = {
  REGISTER: "REGISTER",
  USER_DETAIL: "USER_DETAIL",
  USER_UPDATE: "USER_UPDATE",
  CREATE_USER: "CREATE_USER",
};

export const USER_ROLE_KOJI = {
  APPROVER_HONBU_020: "approver_honbu_020",
  APPROVER_HONBU_SERVICE_OWNER: "approver_honbu_service_owner",
  APPROVER_TENPO: "approver_tenpo",
  APPROVER_HONBU: "approver_honbu",
  APPROVER_NORMAL: "approver_normal",
  PLATFORM_ADMIN: "platform_admin",
  CREATER_PARENT: "creater_parent",
  CREATER: "creater",
};

export const TASK_CODE = {
  TASK01: "TASK01",
  TASK02: "TASK02",
  TASK03: "TASK03",
  TASK04: "TASK04",
  TASK05: "TASK05",
  TASK06: "TASK06",
  TASK07: "TASK07",
};

export const TASK_STATUS = {
  APPLYING: "APPLYING",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  PENDING: "PENDING",
  CANCELLED: "CANCELLED",
};

export const TASK_PROGRESS_STATUS_ENUM = {
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  WAITING_FOR_REVIEW: "WAITING_FOR_REVIEW",
  WAITING_CREATE: "WAITING_CREATE",
  APPROVED_TEMPORARY: "APPROVED_TEMPORARY",
  APPROVED_TEMP_BY_RESPONSIBLE: "APPROVED_TEMP_BY_RESPONSIBLE",
  CANCELLED: "CANCELLED",
  CANCELLED_BY_RESPONSIBLE: "CANCELLED_BY_RESPONSIBLE",
};

export const PROJECT_PROCESS_STATUS_ENUM = {
  REQUEST: "REQUEST",
  ESTIMATE: "ESTIMATE",
  PLAN: "PLAN",
  SCHEDULE_PROGRESS: "SCHEDULE_PROGRESS",
  DATE_CONFIRMED: "DATE_CONFIRMED",
  COMPLETED: "COMPLETED",
};

export const PROJECT_STATUS_ENUM = {
  SUBMITTING: "SUBMITTING",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  ON_HOLD: "ON_HOLD",
  CANCELLED: "CANCELLED",
};

export const DEPARTMENT_OPTIONS = [
  {
    value: "01_共通",
    label: "01_共通",
  },
  {
    value: "10_青果",
    label: "10_青果",
  },
  {
    value: "20_鮮魚",
    label: "20_鮮魚",
  },
  {
    value: "30_精肉",
    label: "30_精肉",
  },
  {
    value: "45_総菜",
    label: "45_総菜",
  },
  {
    value: "48_ベーカリー",
    label: "48_ベーカリー",
  },
  {
    value: "50_グロサリー",
    label: "50_グロサリー",
  },
  {
    value: "70_コルモピア",
    label: "70_コルモピア",
  },
  {
    value: "90_チェックスタンド",
    label: "90_チェックスタンド",
  },
];

export const DEPARTMENT_OPTIONS_NEWEST = [
  {
    value: 1,
    label: "01_共通",
  },
  {
    value: 10,
    label: "10_青果",
  },
  {
    value: 20,
    label: "20_鮮魚",
  },
  {
    value: 30,
    label: "30_精肉",
  },
  {
    value: 45,
    label: "45_総菜",
  },
  {
    value: 48,
    label: "48_ベーカリー",
  },
  {
    value: 50,
    label: "50_グロサリー",
  },
  {
    value: 70,
    label: "70_コルモピア",
  },
  {
    value: 90,
    label: "90_チェックスタンド",
  },
];

export const ROLE_REGISTER = [
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.NORMAL}`,
    label: "一般申請者",
  },
];

export const LIST_ORG = [
  "㈱ｻﾞｲﾏｯｸｽ",
  "東都ﾋﾞﾙ整備工業㈱",
  "㈱三機ｻｰﾋﾞｽ",
  "環境整備㈱",
  "古河電工ビジネス＆ライフサポート株式会社",
];

export const ALL_ROLE = [
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.ROOT}`,
    label: "プラットフォームルート",
  },
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.MANAGER}`,
    label: "プラットフォーム管理者",
  },
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.NORMAL}`,
    label: "プラットフォーム運用者",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.ROOT}`,
    label: "サービスルート",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.MANAGER}`,
    label: "サービス管理者",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.NORMAL}`,
    label: "サービス運用者",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.ROOT}`,
    label: "申請ルート",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.MANAGER}`,
    label: "申請管理者",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.NORMAL}`,
    label: "一般申請者",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.ROOT}`,
    label: "承認ルート",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.MANAGER}`,
    label: "承認管理者",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.NORMAL}`,
    label: "一般承認者",
  },
];

export const PLATFORM_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.MANAGER}`,
    label: "プラットフォーム管理者",
  },
  {
    value: `${USER_GROUP.PLATFORM_ADMIN}_${USER_ROLE.NORMAL}`,
    label: "プラットフォーム運用者",
  },
];

export const ADMIN_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.MANAGER}`,
    label: "サービス管理者",
  },
  {
    value: `${USER_GROUP.ADMIN}_${USER_ROLE.NORMAL}`,
    label: "サービス運用者",
  },
];

export const APPROVER_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.MANAGER}`,
    label: "承認管理者",
  },
  {
    value: `${USER_GROUP.APPROVER}_${USER_ROLE.NORMAL}`,
    label: "一般承認者",
  },
];

export const CREATOR_UPDATE_ROLE = [
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.MANAGER}`,
    label: "申請管理者",
  },
  {
    value: `${USER_GROUP.CREATOR}_${USER_ROLE.NORMAL}`,
    label: "一般申請者",
  },
];

export const STATUS_OPTIONS = [
  {
    value: "SUBMITTING",
    label: "申請中",
  },
  {
    value: "WAITING_FOR_APPROVAL",
    label: "承認待ち",
  },
  {
    value: "IN_PROGRESS",
    label: "進行中",
  },
  {
    value: "COMPLETED",
    label: "完了",
  },
  {
    value: "ON_HOLD",
    label: "保留",
  },
  {
    value: "CANCELLED",
    label: "中止",
  },
];

export const ORG_TYPE = {
  HONBU: "honbu",
  TENPO: "tenpo",
};

export const MODAL_TYPE = {
  CREATE_PROJECT: "create-project",
  CREATE_TASK_REQUEST: "create-task-request",
  CREATE_SECURITY_COMPANY: "create-security-company",
};

export const PRIORITY_OPTIONS = [
  {
    value: 1,
    label: "高",
  },
  {
    value: 2,
    label: "中",
  },
  {
    value: 3,
    label: "低",
  },
];

export const AUTO_APPROVE_OPTIONS = [
  {
    value: 1,
    label: "必要",
  },
  {
    value: 0,
    label: "不要",
  },
];

export const PROJECT_STATUS_OPTIONS = [
  {
    id: 1,
    value: "工事依頼",
    disabled: true,
  },
  {
    id: 2,
    value: "見積作成",
    disabled: true,
  },
  {
    id: 3,
    value: "見積承認",
    disabled: true,
  },
  {
    id: 4,
    value: "実行日連絡",
    disabled: true,
  },
  {
    id: 5,
    value: "実行日時承認",
    disabled: true,
  },
  {
    id: 6,
    value: "警備員手配",
    disabled: true,
  },
  {
    id: 7,
    value: "警備見積承認",
    disabled: true,
  },
  {
    id: 8,
    value: "工事完了書作成",
    disabled: true,
  },
  {
    id: 9,
    value: "工事完了書承認",
    disabled: true,
  },
];

export const SPECIAL_ORG_CODES = ['07006400', '06763100', '06605300', '04045500', '03386300', '01568600'];

export const TASK_PROGRESS_STATUS = [
  {
    key: "WAITING_FOR_APPROVAL",
    label: "承認待ち",
    value: 1,
  },
  {
    key: "APPROVED",
    label: "承認された",
    value: 2,
  },
  {
    key: "REJECTED",
    label: "拒否された",
    value: 3,
  },
];

export const LIMITED_BUDGET = 100000;

export const WORK_START_HOUR = "07:00";
export const WORK_END_HOUR = "17:00";
export const EVENING_START_OFFSET_MINUTES = 30;
export const PHONE_MAXLENGTH = 12;
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const CONTINUOUS_MAPPING = {
  t: "完了",
  f: "継続中",
}
export const FORMAT_TIME = "YYYY-MM-DD HH:mm";
